import { useMemo } from "react";
import { useFetchApi } from "../../hooks/useFetchApi";
import { BillingDetails } from "shared";
import { apiRoutes } from "../../routing/routes";

export const useBilling = () => {
  const { data: billingDetails } = useMemo(
    () => useFetchApi<BillingDetails>(apiRoutes.billing, 2),
    []
  );

  return billingDetails;
};
